import { PEXELS_SEARCH_API } from 'hooks/useImageSearch';
import { PexelsSearchResponse } from 'types/imageLibsTypes';
import { getInfographUri } from 'utils/getInfographUri';
import request from 'utils/request';

type PexelsSearchParams = {
  query: string;
  color?: string;
  page?: number;
  per_page?: number;
};

/**
 * Perform Pexels Image Search
 */
export const PexelsSearch = async (searchParams: PexelsSearchParams) => {
  const queryObj = {
    keywords: searchParams.query,
    per_page: searchParams.per_page?.toString() ?? '20',
    page: searchParams.page?.toString() ?? '1',
  };
  const queryStr = new URLSearchParams(queryObj);
  let requestURL = getInfographUri(`${PEXELS_SEARCH_API}?${queryStr}`);

  return await request<PexelsSearchResponse>(requestURL, {
    method: 'GET',
    credentials: 'omit',
  });
};
